import { AnalyticIdentifier } from '@common/neo.tax';
import { Logo, Typography, colors } from '@ui-components/neo.tax';
import { useLocation } from 'react-router-dom';

import { useAnalyticId } from '@neo.tax/shared';

import { LoginRootContainer } from '../organisms.styled';
import { StyledAuthHero, StyledAuthSubtitle, StyledAuthSwitch } from './auth-form-header.styled';

export const AuthFormHeader = ({
  description,
  form,
  pageChangeLinkText,
  pageChangeText,
  pageChangeTo,
  title,
}: {
  form: React.ReactNode;
  title: string;
  description?: string;
  pageChangeText: string;
  pageChangeLinkText: string;
  pageChangeTo: string;
}): React.ReactElement | null => {
  const switchLoginMethodAnchorId = useAnalyticId(AnalyticIdentifier.RTC_SWITCH_LOGIN_METHOD_BUTTON);
  const { search: locationSearch } = useLocation();

  // Split the target into pathname + search because react-router's `to` prop rejects a
  // pathname containing `?`. When the caller provides their own query string, use it
  // verbatim; otherwise inherit the current location's search (preserves things like
  // ?userId= for super-user impersonation).
  const questionMarkIndex = pageChangeTo.indexOf('?');
  const toPathname = questionMarkIndex >= 0 ? pageChangeTo.slice(0, questionMarkIndex) : pageChangeTo;
  const toSearch = questionMarkIndex >= 0 ? pageChangeTo.slice(questionMarkIndex) : locationSearch;

  return (
    <LoginRootContainer>
      <Logo animated={false} />
      <StyledAuthHero direction="column">
        <Typography as="h2" fontSize="3xl" fontWeight="extrabold">
          {title}
        </Typography>
        {pageChangeText && pageChangeLinkText && (
          <StyledAuthSubtitle as="p" fontSize="sm">
            Or{' '}
            <Typography as="span" fontSize="sm" fontWeight="medium">
              {pageChangeText}{' '}
              <StyledAuthSwitch id={switchLoginMethodAnchorId} to={{ pathname: toPathname, search: toSearch }}>
                {pageChangeLinkText}
              </StyledAuthSwitch>
            </Typography>
          </StyledAuthSubtitle>
        )}
      </StyledAuthHero>

      {description && (
        <Typography as="p" fontSize="base" color={colors.gray[600]}>
          {description}
        </Typography>
      )}
      {form}
    </LoginRootContainer>
  );
};
